/**
 * Coding-agent glyph — bot head with antenna, side "ears", eye dots, and a
 * `</>` mouth. Uses currentColor so it inherits whatever foreground the
 * parent badge/wrapper provides (pastel green in the picker card, white on
 * green on the canvas node, etc.).
 *
 * Visual source of truth for the coding agent identity. The serialized SVG
 * shipped in `data/manifests/codingAgent.ts` uses the same paths so the
 * picker icon (rasterized data URI) matches the JSX version pixel-for-pixel.
 */
export const CodingAgentGlyph = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="11" cy="3.6" r="1" fill="currentColor" />
    <line x1="11" y1="4.6" x2="11" y2="6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    <rect x="4.5" y="6" width="13" height="11" rx="3" fill="currentColor" fillOpacity="0.18" stroke="currentColor" strokeWidth="1" />
    <rect x="3" y="9.5" width="1.6" height="4" rx="0.6" fill="currentColor" />
    <rect x="17.4" y="9.5" width="1.6" height="4" rx="0.6" fill="currentColor" />
    <circle cx="8.7" cy="10" r="1.1" fill="currentColor" />
    <circle cx="13.3" cy="10" r="1.1" fill="currentColor" />
    <path d="M8.4 13.6 L7 14.6 L8.4 15.6" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <path d="M13.6 13.6 L15 14.6 L13.6 15.6" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <path d="M12 13.4 L10 15.8" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" fill="none" />
  </svg>
);
